export enum StyleTypes {
  popover = 'popover',
  tooltip = 'tooltip'
}
